import { render, staticRenderFns } from "./import-step4.vue?vue&type=template&id=42cf33be"
import script from "./import-step4.vue?vue&type=script&lang=js"
export * from "./import-step4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports